import { Box } from '@chakra-ui/react';
import { useEffect } from 'react';

export const RedirectToLogin = () => {
  useEffect(() => {
    window.location.href = '/login';
  }, []);
  return <Box>Redirecting you to login.</Box>;
};
